var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverCardEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 15.883v4.793a1 1 0 0 0 1 1h4.793a.5.5 0 0 0 .353-.147l9.324-9.323-6-6-9.324 9.323a.5.5 0 0 0-.146.354zM13.53 5.145l6 6 1.763-1.762a1 1 0 0 0 0-1.414l-4.586-4.586a1 1 0 0 0-1.414 0L13.53 5.145zm0 7.061a.75.75 0 1 0-1.06-1.06l-5 5a.75.75 0 1 0 1.06 1.06l5-5z",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverCardEdit);
export default __webpack_public_path__ + "static/media/driver-card-edit.ffbf9d53756ef75016e09dd520b3019e.svg";
export { ForwardRef as ReactComponent };